import VerticalAlign from './VerticalAlign';

export default VerticalAlign;



// WEBPACK FOOTER //
// ./src/components/verticalAlign/index.js